// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"shared_mainWrapper__HMfNI","topContent":"shared_topContent__d0XbT","slogan":"shared_slogan__T_YVn","subtitle":"shared_subtitle__jkk4O"};